export const inputHelperMixin = {
  props: {
    input: Object,
    error: Array,
    parentField: String,
    applicationValue: [String, Number, Object, Array, Date],
    applicationValueIndex: [String, Number],
    reviewMode: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    updateInput(parent, key, value, index = null, save = false) {
      return this.$emit("update:input", {
        parent,
        key,
        value,
        index: this.applicationValueIndex,
        save
      });
    }
  }
};
